// Services Section
import { FileText, UserCheck, Star } from 'lucide-react';

interface Service {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const services: Service[] = [
  {
    icon: <FileText className="w-6 h-6 text-white" />,
    title: 'Certificado Digital A1',
    description: 'Compre o certificado digital e-CNPJ A1 com validade de 1 ano por um dos menores preços do mercado.',
  },
  {
    icon: <UserCheck className="w-6 h-6 text-white" />,
    title: 'Implantação Guiada',
    description: 'Agende um atendimento online exclusivo para fazer primeiras configurações com especialista proNotas.',
  },
  {
    icon: <Star className="w-6 h-6 text-white" />,
    title: 'Suporte Premium',
    description: 'Receba atendimento avançado com especialistas em horário estendido via WhatsApp.',
  },
];

export function Services() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="services" className="py-20 bg-white dark:bg-gray-900 relative overflow-hidden">
      {/* Decorative element */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-100 rounded-full opacity-20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
          O <span className="text-green-600">proNotas</span> também tem serviços para você potencializar ainda mais sua gestão
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">{service.title}</h3>
              <p className="text-gray-600 dark:text-gray-300">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollToSection('pricing')}
            className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Comece grátis e contrate os serviços
          </button>
        </div>
      </div>
    </section>
  );
}
